import useFeatureFlag from 'shared/hooks/useFeatureFlag/useFeatureFlag'

const useGiftTrackerRevampFeature = () =>
  useFeatureFlag('24f_ff_gift_tracker_revamp_web', false)

export default useGiftTrackerRevampFeature
